import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { KonstantesQuerySorterConfig } from 'fa-kt.types';
import { KonstantesService } from '../service';

@Component({
  selector: 'fa-kt-konstantes-sorter',
  templateUrl: './konstantes-sorter.component.html',
  styleUrls: ['./konstantes-sorter.component.css'],
})
export class KonstantesSorterComponent {
  KonstantesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public konstantes: KonstantesService,
  ) {
    this.KonstantesSorterConfig = KonstantesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
